export const contactFieldHelp = {
  company: {
    description: 'Empresa à qual este contato pertence. Obrigatório para localizar o cliente no atendimento.',
    example: 'selecione a empresa já cadastrada',
  },
  firstName: {
    description: 'Primeiro nome da pessoa de contato no cliente.',
    example: 'Ana',
  },
  lastName: {
    description: 'Sobrenome da pessoa. Opcional se ainda não estiver confirmado.',
    example: 'Souza',
  },
  email: {
    description: 'E-mail corporativo usado para comunicação e abertura de chamados.',
    example: 'ana.souza@empresa.com.br',
  },
} as const;
